export enum MediaLibraryToastMessages {
  CREATE_SUCCESS = 'The asset was successfully added to Media Library.',
  CREATE_FAILURE = 'The asset could not be uploaded. Please try again.',
  UPDATE_SUCCESS = 'The image has been updated.',
  UPDATE_FAILURE = 'The asset could not be updated. Please try again.',
  DELETE_SUCCESS = 'The image has been deleted.',
  DELETE_FAILURE = 'The asset could not be deleted. Please try again.',
  IMPORT_SUCCESS = 'Successfully imported media files.',
  IMPORT_FAILURE = 'Failed to import media files.',
  EXPORT_SUCCESS = 'Successfully exported media files.',
  EXPORT_FAILURE = 'Failed to export media files.',
}
